import { useLang } from "@/i18n";
import { Reveal } from "@/components/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export const Faq = () => {
  const { t } = useLang();
  return (
    <section className="max-w-7xl mx-auto px-5 md:px-8 py-24 md:py-36" data-testid="faq-section">
      <div className="grid md:grid-cols-12 gap-10 md:gap-16">
        <Reveal className="md:col-span-5">
          <p className="text-xs uppercase tracking-[0.25em] text-[#C86A4B] font-bold mb-3">{t.faq.kicker}</p>
          <h2 className="font-serif-d text-4xl md:text-5xl font-semibold text-[#132A1D] tracking-tight whitespace-pre-line">{t.faq.title}</h2>
          <p className="text-[#5C5C5C] mt-5 leading-relaxed max-w-sm">{t.faq.sub}</p>
        </Reveal>
        <Reveal delay={0.1} className="md:col-span-7">
          <Accordion type="single" collapsible className="w-full">
            {t.faq.items.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="border-black/10">
                <AccordionTrigger data-testid={`faq-q-${i}`} className="text-left font-serif-d text-xl md:text-2xl font-semibold text-[#132A1D] hover:no-underline hover:text-[#2E5A3B] py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent data-testid={`faq-a-${i}`} className="text-[#5C5C5C] leading-relaxed text-base pb-6">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
